// extracted by mini-css-extract-plugin
export var section = "Newsletter-module--section--1iDLa";
export var outerContainer = "Newsletter-module--outerContainer--3nxei";
export var container = "Newsletter-module--container--3BC7U";
export var text = "Newsletter-module--text--VUjp_";
export var form = "Newsletter-module--form--1crjd";
export var inputContainer = "Newsletter-module--inputContainer--3gyTS";
export var input = "Newsletter-module--input--CDMYX";
export var successText = "Newsletter-module--successText--2jttG";
export var btn = "Newsletter-module--btn--3pNO-";